<h1 class="pnc-main-page-title" data-cy="pnc-main-page-title">PNC</h1>
<ng-template #actionButtonsTemplate>
  <div class="pnc-main-page-table-header-buttons">
    @if (!state.hasAdminPermission) {
      <div class="pnc-main-page-segmented-buttons">
        <app-segmented-button (selectedOption)="changeListTab($event)"
        [options]="$safeNavigationMigration(state?.listTypeOptions)"></app-segmented-button>
      </div>
    }
    @if (state.hasPlannerPermission) {
      <div class="pnc-main-page-proxy-management">
        <app-proxy-management (proxyListUpdated)="proxyListUpdated()"></app-proxy-management>
      </div>
    }
  </div>
</ng-template>

<app-table (clearAllFiltersClick)="clearAllFilters()"
  (selectedLine)="loadDetailData($event)"
  (sortedBy)="sortedByChange($event)"
  [accordionLineTemplate]="accordionLineTemplate"
  [actionButtonsTemplate]="actionButtonsTemplate"
  [disableAccordion]="$safeNavigationMigration(state?.disableAccordion)"
  [hasBackgroundBlur]="$safeNavigationMigration(state?.tableHasBlur)"
  [hasClearAllButton]="hasClearAllButton"
  [initiallySortedBy]="initiallySortedBy"
  [isToCloseAccordion]="isToCloseAccordion"
  [scrollEvent]="scrollEvent"
  [tableData]="tableData"
  tableName="table">
</app-table>

@if (hasPagination()) {
  <app-pagination (pageNumber)="changePage($event)"
    [collectionSize]="search.totalResults"
    [pageSize]="search.pageSize"
    [page]="search.pageNumber"
    data-cy="business-settings-list-pagination">
  </app-pagination>
}


<!-- FIXME: this should belong to the new table component, to keep consistent behavior between the old table and the new one. -->
@if (spinnerObservable | async) {
  <div class="spinner-container">
    <app-loading-spinner class="center-spinner"></app-loading-spinner>
  </div>
}

<ng-template #supplyingPackingPlantFilterTemplate>
  <app-code-filter #supplyingPackingPlantFilter
    (filterEvent)="filterChange($event)"
    (onOpen)="getSupplyingPackingPlantFilterCodes()"
    [dataSubject]="supplyingPackingPlantFilterSubject"
    [filterName]="PartNumberChangesColumnEnum.SUPPLYING_PACKING_PLANT"
  placeHolder="Search Supplying Packing Plant"></app-code-filter>
</ng-template>

<ng-template #pncTypeFilterTemplate>
  <app-code-filter #pncTypeFilter
    (filterEvent)="filterChange($event)"
    (onOpen)="getTypeFilterCodes()"
    [dataSubject]="typeFilterSubject"
    [filterName]="PartNumberChangesColumnEnum.TYPE"
    [formatWithoutCode]="true"
  placeHolder="Search by type"></app-code-filter>
</ng-template>


<ng-template #pncNumberFilterTemplate>
  <app-input-and-code-filter #pncNumberFilter
    (filterEvent)="filterChange($event)"
    [filterName]="PartNumberChangesColumnEnum.NUMBER"
  placeHolder="Search by number"></app-input-and-code-filter>
</ng-template>


<ng-template #creationDateFilterTemplate>
  <app-date-filter #creationDateFilter
    (filterEvent)="filterChange($event)"
    [dateDisplayedInUtc]="false"
  [filterName]="PartNumberChangesColumnEnum.CREATION_DATETIME"></app-date-filter>
</ng-template>


<ng-template #partnerFilterTemplate>
  <app-code-filter #partnerFilter
    (filterEvent)="filterChange($event)"
    (onOpen)="getPartnerFilterCodes()"
    [dataSubject]="partnerFilterSubject"
    [filterName]="PartNumberChangesColumnEnum.PARTNER"
  placeHolder="Search by partner"></app-code-filter>
</ng-template>


<ng-template #updatedByFilterTemplate>
  <app-input-and-code-filter #updatedByFilter
    (filterEvent)="filterChange($event)"
    [filterName]="PartNumberChangesColumnEnum.UPDATED_BY"
    formatWithoutCode="true"
  placeHolder="Search by username"></app-input-and-code-filter>
</ng-template>


<ng-template #lastModifyFilterTemplate>
  <app-date-filter #lastModifyFilter
    (filterEvent)="filterChange($event)"
    [dateDisplayedInUtc]="false"
  [filterName]="PartNumberChangesColumnEnum.CHANGED_ON"></app-date-filter>
</ng-template>


<ng-template #oldMaterialFilterTemplate>
  <app-input-and-code-filter #oldMaterialFilter
    (filterEvent)="filterChange($event)"
    [filterName]="PartNumberChangesColumnEnum.OLD_MATERIAL_NUMBER"
  placeHolder="Search by material"></app-input-and-code-filter>
</ng-template>


<ng-template #statusFilterTemplate>
  <app-code-filter #statusFilter
    (filterEvent)="filterChange($event)"
    (onOpen)="getStatusFilterCodes()"
    [dataSubject]="statusFilterSubject"
    [filterName]="PartNumberChangesColumnEnum.STATUS"
    [formatWithoutCode]="true"
  placeHolder="Search by status"></app-code-filter>
</ng-template>

<ng-template #newMaterialFilterTemplate>
  <app-input-and-code-filter #newMaterialFilter
    (filterEvent)="filterChange($event)"
    [filterName]="PartNumberChangesColumnEnum.NEW_PART_NUMBER"
  placeHolder="Search by material"></app-input-and-code-filter>
</ng-template>

<ng-template #technicianGroupFilterTemplate>
  <app-code-filter #technicianGroupFilter
    (filterEvent)="filterChange($event)"
    (onOpen)="getTechnicianGroupFilterCodes()"
    [dataSubject]="technicianGroupFilterSubject"
    [filterName]="PartNumberChangesColumnEnum.TECHNICIAN_GROUP"
    [formatWithoutCode]="true"
  placeHolder="Search Technician Group"></app-code-filter>
</ng-template>

<ng-template #accordionLineTemplate>
  <app-part-number-changes-detail (footerAction)="triggerFooterAction($event)"
    (stickyHeaderAction)="triggerStickyHeaderAction($event)"
    [detailData]="accordionContext"
  [updateState]="updatePNCDetailState"></app-part-number-changes-detail>
</ng-template>


<ng-template #createdByFilterTemplate>
  <app-input-and-code-filter #createdByFilter
    (filterEvent)="filterChange($event)"
    [filterName]="PartNumberChangesColumnEnum.CREATED_BY"
    formatWithoutCode="true"
  placeHolder="Search by username"></app-input-and-code-filter>
</ng-template>

<ng-template #doneFilterTemplate>
  <app-code-filter #doneFilter
    (filterEvent)="filterChange($event)"
    [codes]="doneFilterCodes"
    [filterName]="PartNumberChangesColumnEnum.DONE"
    [formatWithoutCode]="true"
  disableInputFilter="true"></app-code-filter>
</ng-template>
